import { Form, Formik } from "formik";
import { handleSubmitForm } from "helpers/apiUtils";
import { Row, Col} from "react-bootstrap";
import React, {  useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  changeAdminUserPasswordSchema,
} from "utils/validations";
import CustomField from "components/form/CustomField";
import { Eye, EyeOff } from "lucide-react";
import { updatePassword } from "store/slices/usersSlice";
import { showAlert } from "store/slices/alertSlice";

function ChangePassword({ updatingUserId,setShowOptionsModal, onSuccess = () => {} }) {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const dispatch = useDispatch();

  const [initialValues, setInitialValues] = useState({
    id :updatingUserId,
    newPassword: "",
    confirmPassword: "",
  });
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
    const { isLoading } = useSelector((state) => state.Users);
  

  const handleSubmitChangePassword = (values) => {
    const payload = {
      ...initialValues,
      newPassword: values.newPassword,
      confirmPassword: values.confirmPassword,
    };

    handleSubmitForm({
      dispatch,
      action: updatePassword,
      payload,
      onSuccess: () => {
        onSuccess();
        dispatch(
          showAlert({
            text: t(`Password updated successfully`),
            type: "success",
          }),
        );
      },
    });
  };

  return (
    <div className="common_modal_card change_password">
      <div className="heading mb-2">
        <h2>{t("Change Password")}</h2>
      </div>
      <Formik
        initialValues={initialValues}
        enableReinitialize
        validationSchema={changeAdminUserPasswordSchema(t)}
        onSubmit={handleSubmitChangePassword}
      >
        {() => (
          <Form>
            <Row>
              <Col lg={12}>
                <div className="form_field position-relative">
                  <CustomField
                    name="newPassword"
                    type={showNewPassword ? "text" : "password"}
                    label={t("Password")}
                    placeholder={t("Enter password")}
                  />
                  <button
                    className="transparent_btn show_hide_password_btn"
                    type="button"
                    onClick={() => setShowNewPassword(!showNewPassword)}
                  >
                    {showNewPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                  </button>
                </div>
              </Col>
              <Col lg={12}>
                <div className="form_field position-relative">
                  <CustomField
                    name="confirmPassword"
                    type={showConfirmPassword ? "text" : "password"}
                    label={t("Confirm Password")}
                    placeholder={t("Enter Confirm password")}
                  />
                  <button
                    className="transparent_btn show_hide_password_btn"
                    type="button"
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  >
                    {showConfirmPassword ? (
                      <EyeOff size={20} />
                    ) : (
                      <Eye size={20} />
                    )}
                  </button>
                </div>
              </Col>

              <Col lg={12} className="d-flex justify-content-end gap-2 mt-3">
                <button
                  type="button"
                  className="main_btn outline"
                  onClick={() => {
                    setShowOptionsModal(false);
                  }}
                >
                  {t("Cancel")}
                </button>

                <button type="submit" className="main_btn" disabled={isLoading}>
                  {t("Save Changes")}
                </button>
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
    </div>
  );
}

export default ChangePassword;
